// internal-deps
import { Some, Option, None } from "@swiggy-private/js-fp";
import { isAbortError, isNetworkError } from "@swiggy-private/core-ui";
import { isPlainObject } from "@swiggy-private/js-utils";

// constants
import { TEXTS } from "@core-utils/constants/TextDict";

// utils
import { showNativeAlert } from "@core-utils/utils/Native";

// interfaces
import { ApiResponse } from "@core-utils/interfaces/Api";

export function isApiResponse<T>(response: unknown): response is ApiResponse<T> {
    return isPlainObject(response) && "statusCode" in response;
}

export function showApiError(err: unknown): void {
    let message: Option<string> = None;
    let title: Option<string> = None;

    if (isApiResponse(err)) {
        message = Some(err.statusMessage || null);
        title = Some(err.statusTitle);
    } else if (isNetworkError(err)) {
        title = Some(TEXTS.CONNECTION_ERROR);
        message = Some(TEXTS.NETWORK_CONNECTIVITY_RETRY_MSG);
    } else if (isAbortError(err)) {
        title = Some(TEXTS.ABORT_ERROR);
        message = Some(TEXTS.ABORTED_REQUEST_ERROR_MSG);
    }

    showNativeAlert({
        message: message.unwrapOr(TEXTS.OOPS_SOMETHING_WENT_WRONG),
        title: title.unwrapOr(" "),
    });
}

let nativeNetworkErrorAlertVisible = false;

export function showNetworkError(err: unknown): void {
    if (!isNetworkError(err) || nativeNetworkErrorAlertVisible) {
        return;
    }

    nativeNetworkErrorAlertVisible = true;
    showNativeAlert({
        title: TEXTS.CONNECTION_ERROR,
        message: TEXTS.NETWORK_CONNECTIVITY_RETRY_MSG,
    })
        .then(_res => {
            nativeNetworkErrorAlertVisible = false;
        })
        .catch(_err => {
            nativeNetworkErrorAlertVisible = false;
        });
}
